import graphql__76398f64a9e1edfd9db7 from "./__generated__/AnswerPreviewMatrix_answer.graphql.js";import { createFragmentContainer } from "react-relay";
import { graphql } from "react-relay";

const AnswerPreviewMatrix = props => {
  const { itemOptions } = props.answer;
  const { items, options } = props.answer.formField;

  const isChecked = optionValue => {
    const { itemId, optionId } = optionValue;

    return itemOptions.some(
      itemOption => itemOption.item.id === itemId && itemOption.option.id === optionId
    );
  };

  return (
    <div className="matrix-input-preview">
      <table className="table table-striped table-hover table-matrix">
        <thead>
          <tr className="matrix-input-header-row">
            <th></th>
            {options.map(option => (
              <th key={option.id}>{option.name}</th>
            ))}
          </tr>
        </thead>

        <tbody>
          {items.map(({ id: itemId, label: itemLabel }) => (
            <tr key={itemId} className="matrix-input-item-row">
              <th className="matrix-input-row-heading">{itemLabel}</th>

              {options.map(({ id: optionId }) => (
                <td key={optionId} className="matrix-input-row-option">
                  {isChecked({ itemId, optionId }) && (
                    <span className="matrix-input-row-option-checked">
                      <i className="fas fa-check"></i>
                    </span>
                  )}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default createFragmentContainer(AnswerPreviewMatrix, {
  answer: graphql__76398f64a9e1edfd9db7
});
